// extracted by mini-css-extract-plugin
export default {"window":"CreatingReservationWindow_window__L5VB-"};